import React, {ChangeEvent, ReactElement} from 'react';
import {Theme, THEME_NUMBER, themes} from '../../../../../../themes';
import {Props} from './Props';
import StyledSelect from '../../../../../../components/StyledSelect';
import StyledLabel from '../../../../../../components/StyledLabel';
import StyledInput from '../../../../../../components/StyledInput';
import {TrafficCenter} from '../../../../../../interfaces/TrafficCenter';

class UserSettingsPane extends React.Component<Props> {
    userSelectedNewTheme = (value: string): void => {
        this.props.changeCurrentTheme(parseInt(value, 10) as THEME_NUMBER);
    };

    userSelectedNewTrafficCenter = (name: string): void => {
        const {trafficCenters, selectedNewTrafficCenter} = this.props;

        if (name.length === 0) {
            selectedNewTrafficCenter(null);
        }

        let trafficCenter: TrafficCenter | null = null;
        trafficCenters.forEach((item: TrafficCenter) => {
            if (item.name === name) {
                trafficCenter = item;
            }
        });

        selectedNewTrafficCenter(trafficCenter);
    };

    render(): ReactElement {
        const {
            currentTrafficCenter,
            currentThemeID,
            mapSettings,
            trafficCenters,
            showRecordIds,
            showTrafficJamIcons,
            mapMovementAvailable,
            onToggleShowTrafficJamIcons,
            onToggleShowRecordIds,
            onToggleMapMovementAvailable,
        } = this.props;

        return (
            <>
                <StyledLabel title={'Verkeerscentrale'} />
                <StyledSelect
                    value={currentTrafficCenter ? currentTrafficCenter.name : undefined}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => this.userSelectedNewTrafficCenter(e.target.value)}
                >
                    <option value={''}>Geen selectie</option>
                    {trafficCenters.map((trafficCenter: TrafficCenter) => (
                        <option value={trafficCenter.name} key={trafficCenter.name}>
                            {trafficCenter.name}
                        </option>
                    ))}
                </StyledSelect>
                <StyledLabel title={'Toon file iconen'} />
                <StyledSelect
                    value={showTrafficJamIcons ? 'true' : 'false'}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                        onToggleShowTrafficJamIcons(e.target.value === 'true')
                    }
                >
                    <option value={'true'}>Ja</option>
                    <option value={'false'}>Nee</option>
                </StyledSelect>
                <StyledLabel title={'Kleurensamenstelling'} />
                <StyledSelect
                    value={currentThemeID}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => this.userSelectedNewTheme(e.target.value)}
                >
                    {themes.map((theme: Theme) => (
                        <option value={theme.index} key={theme.index}>
                            {theme.name}
                        </option>
                    ))}
                </StyledSelect>

                <StyledLabel title={'ID\'s weergeven bij records'} />
                <StyledSelect
                    value={showRecordIds ? 'true' : 'false'}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => onToggleShowRecordIds(e.target.value === 'true')}
                >
                    <option value={'true'}>Ja</option>
                    <option value={'false'}>Nee</option>
                </StyledSelect>

                <StyledLabel title={'Lijn offset (FCD Trajecten en RWS keten)'} />
                <StyledInput
                    type={'number'}
                    value={mapSettings.travelTimeFcdOffset}
                    changeInput={(e: string) => {
                        this.props.setNewTravelTimeLineOffset(parseInt(e || '0', 10));
                    }}
                />

                <StyledLabel title={'Bevriezen van de locatie en zoom niveau'} />
                <StyledSelect
                    value={mapMovementAvailable ? 'true' : 'false'}
                    onChange={() => onToggleMapMovementAvailable()}
                >
                    <option value={'false'}>Bevroren</option>
                    <option value={'true'}>Verplaatsing is mogelijk</option>
                </StyledSelect>
            </>
        );
    }
}

export default UserSettingsPane;
